'use client';
import {
  Drawer, List, ListItemButton, ListItemIcon, ListItemText,
  Toolbar, Typography, Box, Divider,
} from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PeopleIcon from '@mui/icons-material/People';
import DescriptionIcon from '@mui/icons-material/Description';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import BarChartIcon from '@mui/icons-material/BarChart';
import PlaceIcon from '@mui/icons-material/Place';
import DirectionsBoatIcon from '@mui/icons-material/DirectionsBoat';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import SettingsIcon from '@mui/icons-material/Settings';
import { usePathname, useRouter } from 'next/navigation';

const WIDTH = 240;

const navItems = [
  { label: 'Dashboard',       icon: <DashboardIcon />,       path: '/' },
  { label: 'Fornecedores',    icon: <PeopleIcon />,          path: '/fornecedores' },
  { label: 'Compra da Castanha', icon: <DescriptionIcon />,  path: '/contratos' },
  { label: 'Origens',         icon: <PlaceIcon />,           path: '/origens' },
  { label: 'Embarque na Origem', icon: <DirectionsBoatIcon />, path: '/embarque-origem' },
  { label: 'Rotas',           icon: <LocalShippingIcon />,   path: '/rotas' },
  { label: 'Fechamento',      icon: <FactCheckIcon />,       path: '/fechamentos' },
  { label: 'Conta Corrente',  icon: <ReceiptLongIcon />,     path: '/financeiro' },
  { label: 'Relatórios',      icon: <BarChartIcon />,        path: '/relatorios' },
  { label: 'Configuração',    icon: <SettingsIcon />,        path: '/configuracoes' },
];

export function Sidebar() {
  const pathname = usePathname();
  const router = useRouter();

  return (
    <Drawer
      variant="permanent"
      sx={{
        width: WIDTH,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: WIDTH,
          boxSizing: 'border-box',
          bgcolor: 'primary.main',
          color: 'white',
          borderRight: 'none',
        },
      }}
    >
      <Toolbar sx={{ px: 2, py: 1.5 }}>
        <Box>
          <Typography variant="h6" sx={{ color: 'white', lineHeight: 1.2 }}>
            Castanha do Pará
          </Typography>
          <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.7)' }}>
            Mutran Exportadora
          </Typography>
        </Box>
      </Toolbar>

      <Divider sx={{ borderColor: 'rgba(255,255,255,0.15)' }} />

      <List sx={{ px: 1, pt: 1 }}>
        {navItems.map((item) => {
          const active = item.path === '/'
            ? pathname === '/'
            : pathname.startsWith(item.path);
          return (
            <ListItemButton
              key={item.path}
              onClick={() => router.push(item.path)}
              sx={{
                borderRadius: 2,
                mb: 0.5,
                color: active ? 'white' : 'rgba(255,255,255,0.7)',
                bgcolor: active ? 'rgba(255,255,255,0.15)' : 'transparent',
                '&:hover': { bgcolor: 'rgba(255,255,255,0.1)', color: 'white' },
              }}
            >
              <ListItemIcon sx={{ color: 'inherit', minWidth: 36 }}>{item.icon}</ListItemIcon>
              <ListItemText primary={item.label} primaryTypographyProps={{ fontSize: 14, fontWeight: active ? 600 : 400 }} />
            </ListItemButton>
          );
        })}
      </List>
    </Drawer>
  );
}
